module.exports = __webpack_public_path__ + "static/img/19078D_1_2_C_20210606_LC.443525d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/19078D_1_2_C_20210606_LC.png
// module id = p7U4
// module chunks = 0